module.exports = __webpack_public_path__ + "static/media/Spain_flag.30e2939e.png";